var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOro(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 24,
    viewBox: "0 0 29 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8303 13.6633H16.0639H18.9868M12.8303 13.6633H8.95518M12.8303 13.6633L10.9126 19.7281M8.95518 13.6633H7.57311H6.00588H2.90448L1 19.7281H2.82513M8.95518 13.6633L10.9126 19.7281M19.0265 19.7281H20.8582M10.9126 19.7281H16.183M10.9126 19.7281H9.05437M26.0955 7.24953L28 13.239L20.8516 19.7281L18.9802 13.6633L26.0955 7.24953ZM26.0955 7.24953L23.1131 7.05103M7.24908 9.59054L2.91109 13.6633M7.24908 9.59054L7.84423 7.63286M7.24908 9.59054L6.01249 13.6633M16.9699 4.84692L14.0007 7.63286L16.0573 13.6633M18.1999 3.69011L21.0698 1L23.1131 7.05103M23.1131 7.05103L16.0639 13.6702M7.84423 7.63286L9.7421 5.88052M7.84423 7.63286H9.33872H14.0073M11.4945 4.26509L15.0389 1H16.4078H21.0764M5.08009 18.804L2.74578 19.6938L5.08009 20.5837L5.93975 23L6.79941 20.5837L9.13372 19.6938L6.79941 18.804L5.93975 16.3877L5.08009 18.804ZM17.0889 3.72433L15.5614 4.30616L17.0889 4.88799L17.651 6.4692L18.2131 4.88799L19.7406 4.30616L18.2131 3.72433L17.651 2.14312L17.0889 3.72433Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOro);
export default __webpack_public_path__ + "static/media/oro.dc95ba9a88db8702309c8c9d07564b73.svg";
export { ForwardRef as ReactComponent };